"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.solutionAdvanceValue = void 0;
const Actions = __importStar(require("../actions"));
const solution_1 = require("../solution");
const Values = __importStar(require("../value"));
function solutionAdvanceValue(mod, value) {
    if (value["@kind"] === "TypedNeutral") {
        return solutionAdvanceNeutral(mod, value.type, value.neutral);
    }
    return value;
}
exports.solutionAdvanceValue = solutionAdvanceValue;
/**

   To prepare for unify is `walk` the pattern variable,
   and possibly to further evaluate neutral value.

   For both `walk` and further evaluation,
   only one step is needed, not need to do `deepWalk`.

**/
function solutionAdvanceNeutral(mod, type, neutral) {
    switch (neutral["@kind"]) {
        case "Var": {
            return Values.TypedNeutral(type, neutral);
        }
        case "PatternVar": {
            const result = (0, solution_1.solutionWalk)(mod.solution, Values.TypedNeutral(type, neutral));
            if (result["@kind"] === "TypedNeutral" &&
                result.neutral["@kind"] === "PatternVar" &&
                result.neutral.name === neutral.name) {
                return result;
            }
            else {
                return solutionAdvanceValue(mod, result);
            }
        }
        case "Ap": {
            return Actions.doAp(solutionAdvanceNeutral(mod, neutral.targetType, neutral.target), neutral.arg.value);
        }
        case "ApImplicit": {
            return Actions.doApImplicit(solutionAdvanceNeutral(mod, neutral.targetType, neutral.target), neutral.arg.value);
        }
        case "Car": {
            return Actions.doCar(solutionAdvanceNeutral(mod, neutral.targetType, neutral.target));
        }
        case "Cdr": {
            return Actions.doCdr(solutionAdvanceNeutral(mod, neutral.targetType, neutral.target));
        }
        case "Dot": {
            // NOTE Dot value fulfilled class `targetType`,
            //   do this in `Actions.doDot` would be too slow.
            if (Values.isClazz(neutral.targetType)) {
                const target = solutionAdvanceNeutral(mod, neutral.targetType, neutral.target);
                const found = Values.clazzLookupProperty(target, neutral.targetType, neutral.name);
                if (found)
                    return solutionAdvanceValue(mod, found);
            }
            return Actions.doDot(solutionAdvanceNeutral(mod, neutral.targetType, neutral.target), neutral.name);
        }
        case "Replace": {
            return Actions.doReplace(solutionAdvanceNeutral(mod, neutral.targetType, neutral.target), neutral.motive.value, neutral.base.value);
        }
    }
}
//# sourceMappingURL=solutionAdvanceValue.js.map